import fetch from 'node-fetch'
import { auth } from '../Firebase'
import { formatFetchError, formatNetworkError } from './apiErrors'
// const MODE = process.env.NODE_ENV
// const URL = MODE == 'develop' ? "http://localhost:8000/api" : "https://autobot.rentalios.com/api"
const URL = 'https://rentalios-management-helxajom3a-uc.a.run.app/api'
// const URL = "http://localhost:3000/api"
const URLPRICING = URL + '/rental/dynamic_price?'

/**
 *
 * @param {string} route
 * @param {object} body
 */
async function AUTH(route, body = {}) {
  let composed_url = [URL, route].join('/')
  try {
    const result = await fetch(composed_url, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: { 'Content-Type': 'application/json' }
    })
    const json = await result.json()
    if (!result.ok) {
      const apiError = formatFetchError(result, json)
      return { message: apiError.message, error: apiError }
    }
    return json
  } catch (err) {
    const apiError = formatNetworkError(err)
    return { message: apiError.message, error: apiError }
  }
}

/**
 *
 * @param {String} route
 * @param {String} id
 * @description id is a 32 bit number string, 19 characters tops
 */
async function GET(route, id) {
  const key = 'db31a33d-9efb-4112-a246-6e60cbd779a8'
  let composed_url = [URL, route, id].join('/')
  composed_url += `?key=${key}`
  try {
    const result = await fetch(composed_url)
    const json = await result.json()
    if (!result.ok) {
      const apiError = formatFetchError(result, json)
      return { message: apiError.message, error: apiError }
    }
    return json
  } catch (err) {
    const apiError = formatNetworkError(err)
    return { message: apiError.message, error: apiError }
  }
}

/**
 *
 * @param {String} route
 * @param {String} id
 * @description id is a 32 bit number string, 19 characters tops
 */
async function GETPRICING(
  min_price,
  max_price,
  start_date,
  end_date,
  property,
  room,
  adjustment = true
) {
  let composed_url = `${URLPRICING}min_price=${min_price}&max_price=${max_price}&start_date=${start_date}&end_date=${end_date}&property_id=${property}&room_id=${room}&adjustment=${adjustment}`
  try {
    const result = await fetch(composed_url)
    const json = await result.json()
    if (!result.ok) {
      const apiError = formatFetchError(result, json)
      return { message: apiError.message, error: apiError }
    }
    return json
  } catch (err) {
    const apiError = formatNetworkError(err)
    return { message: apiError.message, error: apiError }
  }
}

/**
 * GET /rental/actual-rent with query params (same style as dynamic_price).
 * @param {string} room_id
 * @param {string} start_date - e.g. "9/11/2025"
 * @param {string} end_date - e.g. "9/11/2026"
 */
async function GETACTUALRENT(room_id, start_date, end_date) {
  const key = 'db31a33d-9efb-4112-a246-6e60cbd779a8'
  const composed_url = `${URL}/rental/actual-rent?room_id=${room_id}&start_date=${start_date}&end_date=${end_date}&key=${key}`
  try {
    const result = await fetch(composed_url)
    const json = await result.json()
    if (!result.ok) {
      const apiError = formatFetchError(result, json)
      return { message: apiError.message, error: apiError }
    }
    return json
  } catch (err) {
    const apiError = formatNetworkError(err)
    return { message: apiError.message, error: apiError }
  }
}

/**
 *
 * @param {string} route
 * @param {object} body
 * @param {string} field
 * @param {string} value
 */
async function POST(route, body = {}, field = undefined, value = undefined) {
  if (field) body[field] = value
  let composed_url = [URL, route].join('/')
  composed_url += `?key=${auth.currentUser.Aa}&email=${auth.currentUser.email}`
  try {
    const result = await fetch(composed_url, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: { 'Content-Type': 'application/json' }
    })
    const json = await result.json()
    if (!result.ok) {
      const apiError = formatFetchError(result, json)
      return { message: apiError.message, error: apiError }
    }
    return json
  } catch (err) {
    const apiError = formatNetworkError(err)
    return { message: apiError.message, error: apiError }
  }
}
/**
 *
 * @param {String} route
 * @param {Stirng} id
 * @param {Object} body
 * @param {String} field
 * @param {String} value
 */
async function PUT(route, id, body = {}, field = undefined, value = undefined) {
  if (field) body[field] = value
  let composed_url = [URL, route, id].join('/')
  composed_url += `?key=${auth.currentUser.Aa}&email=${auth.currentUser.email}`
  try {
    const result = await fetch(composed_url, {
      method: 'PUT',
      body: JSON.stringify(body),
      headers: { 'Content-Type': 'application/json' }
    })
    const json = await result.json()
    if (!result.ok) {
      const apiError = formatFetchError(result, json)
      return { message: apiError.message, error: apiError }
    }
    return json
  } catch (err) {
    const apiError = formatNetworkError(err)
    return { message: apiError.message, error: apiError }
  }
}

/**
 *
 * @param {String} route
 * @param {String} id
 */
async function DELETE(route, id) {
  let composed_url = [URL, route, id].join('/')
  composed_url += `?key=${auth.currentUser.Aa}&email=${auth.currentUser.email}`
  try {
    const result = await fetch(composed_url, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' }
    })
    const json = await result.json()
    if (!result.ok) {
      const apiError = formatFetchError(result, json)
      return { message: apiError.message, error: apiError }
    }
    return json
  } catch (err) {
    const apiError = formatNetworkError(err)
    return { message: apiError.message, error: apiError }
  }
}

/**
 *
 * @param {String} route
 * @param {String} id
 * @param {String} roomId
 * @param {String} email
 */
async function DELETE_WITH_ROOM_ID_AND_EMAIL(route, id, roomId, email) {
  let composed_url = [URL, route, id, roomId, email].join('/')
  composed_url += `?key=${auth.currentUser.Aa}&email=${auth.currentUser.email}`
  try {
    const result = await fetch(composed_url, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' }
    })
    const json = await result.json()
    if (!result.ok) {
      const apiError = formatFetchError(result, json)
      return { message: apiError.message, error: apiError }
    }
    return json
  } catch (err) {
    const apiError = formatNetworkError(err)
    return { message: apiError.message, error: apiError }
  }
}

export default {
  AUTH,
  GET,
  POST,
  PUT,
  DELETE,
  DELETE_WITH_ROOM_ID_AND_EMAIL,
  GETPRICING,
  GETACTUALRENT
}
